<script setup>
import { ref, computed } from 'vue';
import { useStore } from 'dashboard/composables/store';
import { useAlert } from 'dashboard/composables';

import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  entity: { type: Object, required: true },
  type: { type: String, required: true },
});

const emit = defineEmits(['delete-success']);

const store = useStore();
const dialogRef = ref(null);
const isDeleting = ref(false);

const entityName = computed(() => props.entity?.title || props.entity?.name);

const handleDelete = async () => {
  try {
    isDeleting.value = true;
    await store.dispatch('voiceAgentActions/delete', props.entity.id);
    useAlert('Action deleted successfully');
    dialogRef.value.close();
    emit('delete-success');
  } catch (error) {
    useAlert(error.message || 'Failed to delete action');
  } finally {
    isDeleting.value = false;
  }
};

defineExpose({ dialogRef });
</script>

<template>
  <Dialog ref="dialogRef" :title="$t('AI_VOICE.ACTIONS.DELETE_TITLE')">
    <div class="space-y-4">
      <p class="text-sm text-n-slate-11">
        {{ $t('AI_VOICE.ACTIONS.DELETE_CONFIRMATION', { name: entityName }) }}
      </p>

      <div class="flex justify-end gap-3 pt-4">
        <Button
          variant="hollow"
          color="slate"
          :label="$t('COMMON.CANCEL')"
          :disabled="isDeleting"
          @click="dialogRef.close()"
        />
        <Button
          variant="solid"
          color="red"
          :label="$t('COMMON.DELETE')"
          :is-loading="isDeleting"
          :disabled="isDeleting"
          @click="handleDelete"
        />
      </div>
    </div>
  </Dialog>
</template>
